import script from "./AllArticleView.vue?vue&type=script&setup=true&lang=js"
export * from "./AllArticleView.vue?vue&type=script&setup=true&lang=js"

import "./AllArticleView.vue?vue&type=style&index=0&id=528e2d56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-528e2d56"]])

export default __exports__